"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("./components/Markdown.cjs"),r=require("./extensions/index.cjs");exports.Markdown=e.default;exports.extensions=r;
//# sourceMappingURL=index.cjs.map
